import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CTASection from "@/components/CTASection";
import SEO from "@/components/SEO";

export default function Team() {
  const [team, setTeam] = useState([]);
  useEffect(() => {
    api.get("/team").then((r) => setTeam(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="team-page">
      <SEO title="Team" description="Meet the Onboard Marketing team — the creative, strategic people behind the work." />
      <section className="pt-16 pb-16 lg:pt-24">
        <div className="ob-container">
          <h1 className="ob-h1 max-w-4xl">
            Meet your marketing team.
          </h1>
        </div>
      </section>

      <section className="pb-32">
        <div className="ob-container space-y-24">
          {team.map((m, idx) => (
            <div key={m.id} data-testid={`team-member-${m.name.toLowerCase()}`} className="grid lg:grid-cols-12 gap-10 items-start">
              <div className={`lg:col-span-5 ${idx % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="aspect-[4/5] rounded-3xl overflow-hidden bg-[var(--ob-bg-alt)] max-w-md">
                  <img src={m.image} alt={m.name} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className={`lg:col-span-7 ${idx % 2 === 1 ? "lg:order-1" : ""}`}>
                <div className="ob-eyebrow mb-4">{m.role}</div>
                <h2 className="ob-h2">{m.name}</h2>
                <div className="mt-8 space-y-5">
                  {(m.bio || "").split(/\n\n+/).map((para, i) => (
                    <p key={i} className="ob-lead">{para}</p>
                  ))}
                </div>
                <div className="mt-8">
                  <div className="ob-eyebrow mb-3">Areas of expertise</div>
                  <div className="flex flex-wrap gap-2">
                    {m.expertise?.map((e) => (
                      <span key={e} className="ob-btn ob-btn-ghost h-9 px-4 text-[13px] cursor-default">{e}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
